<template>
  <v-sheet class="mx-auto">
    <v-slide-group show-arrows v-model="model" class="pa-4" center-active>
      <v-slide-item
        v-for="(brand, i) in brands"
        :key="i"
        v-slot="{ active, toggle }"
      >
        <v-card class="ma-8" height="200" width="320" @click="toggle" flat>
          <v-row class="fill-height" align="center" justify="center">
            <v-img contain :src="brand.src" />
          </v-row>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
export default {
  name: "BrandSlide",
  data: () => ({
    model: null,
    brands: [
      {
        src: "/brands/1.png"
      },
      {
        src: "/brands/2.png"
      },
      {
        src: "/brands/3.png"
      },
      {
        src: "/brands/4.png"
      },
      {
        src: "/brands/5.png"
      },
      {
        src: "/brands/6.png"
      },
      {
        src: "/brands/7.png"
      },
      {
        src: "/brands/8.png"
      },
      {
        src: "/brands/9.png"
      },
      {
        src: "/brands/10.png"
      },
      {
        src: "/brands/11.png"
      },
      {
        src: "/brands/12.png"
      },
      {
        src: "/brands/13.png"
      },
      {
        src: "/brands/14.png"
      }
    ]
  })
};
</script>

<style scoped></style>
